var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlAllInclusiveOutlined = function SvgHtlAllInclusiveOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.304 3.873a.438.438 0 0 0-.342-.71h-1.994l.623-1.1a.437.437 0 1 0-.76-.432L9.962 3.16h-7.5a.437.437 0 0 0-.341.71l5.153 6.442v4.222H5.525a.437.437 0 1 0 0 .875H9.9a.438.438 0 0 0 0-.875H8.15v-4.222l5.154-6.439Zm-5.592 5.59-4.34-5.425h6.093l-.528.928a1.283 1.283 0 0 0-.35-.053 1.32 1.32 0 1 0 1.07.557l.815-1.432h1.58l-4.34 5.425Zm1.313-3.238a.437.437 0 1 1-.874 0 .437.437 0 0 1 .874 0Z"
  })));
};
export default SvgHtlAllInclusiveOutlined;